import { render, staticRenderFns } from "./DeliveryAdd.vue?vue&type=template&id=0dc05f36&scoped=true"
import script from "./DeliveryAdd.vue?vue&type=script&lang=js"
export * from "./DeliveryAdd.vue?vue&type=script&lang=js"
import style0 from "./DeliveryAdd.vue?vue&type=style&index=0&id=0dc05f36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc05f36",
  null
  
)

export default component.exports